export const getConstructionNumberIds = () => {
    switch (window.__ENVIRONMENT_DETAILS__.areaId) {
        case 'a0i2X00000D6143QAB':
            // Cloudvillage area
            return [
                'a083O0000000kDoQAI',
                'a083O0000000kEmQAI',
                'a083O0000000kEHQAY',
                'a083O0000000kDwQAI',
                'a083O0000000kEFQAY',
                'a083O0000000kDeQAI',
                'a083O0000001V6JQAU',
                'a083O000001FaG0QAK',
                'a082X00001BuqrmQAB',
                'a083O0000000kIXQAY',
                'a083O0000000kISQAY',
                'a083O0000000kITQAY',
                'a083O0000000kIOQAY',
            ];
        case 'a0i3O000002cuSzQAI':
            // Netherlands area
            return [
                'a083O000003qMauQAE',
                'a083O000003qMYuQAM',
                'a083O0000045ZIBQA2',
                'a083O000003qMYfQAM',
                'a083O000003qMY6QAM',
            ];
        case 'a0iw0000008QvIVAA0':
            // Hoef en haag
            return [
                'a08QB00000QUuDuYAL',
                // 'a08QB00000QUuDvYAL',
                'a08QB00000QUuDyYAL',
                'a08QB00000QUuDzYAL',
                // 'a08QB00000QUuE2YAL',
                'a08QB00000QUuE3YAL',
                'a08QB00000QVOOrYAP',
                // 'a08QB00000QVIzRYAX',
                // 'a08QB00000QVIzSYAX',
                'a08QB00000QVOOsYAP',
                'a08QB00000QVIzTYAX',
                // 'a08QB00000QVOOtYAP',
                // 'a08QB00000QbUY4YAN',
                'a08QB00000QbUY3YAN',
            ];
    }

    return [];
};
